// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2NBWE","approved":"Status_approved__1MwBN","rejected":"Status_rejected__3rlWB","expired":"Status_expired__zlsGS","label":"Status_label__1w-vI"};